import { Link, usePage } from "@inertiajs/react";
import { ClipboardPasteIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/hooks/use-mobile";
import type { GlobalPageProps } from "@/types/globals";

/**
 * The "from WA template" entry point, which sits next to Create booking on every appointment
 * list — Drafts, visits and Orders. One component rather than three copies: the three lists
 * are already three near-identical toolbars, and a button that drifts on one of them sends
 * admins somewhere the others do not.
 *
 * Renders nothing while PASTE_WA_FORM is off — the router hands out a null path then, and
 * the route guard is what actually refuses the page.
 */
export function PasteWaFormButton() {
	const { t } = useTranslation("appointments");
	const { props: globalProps } = usePage<GlobalPageProps>();
	const isMobile = useIsMobile();
	const href =
		globalProps.adminPortal?.router?.adminPortal?.appointment?.pasteWaForm;

	if (!href) return null;

	return (
		<Button
			asChild
			variant="primary-outline"
			size={isMobile ? "icon" : "default"}
			className="shadow-none"
		>
			<Link href={href}>
				<ClipboardPasteIcon />
				{isMobile ? null : t("drafts.paste_wa_form.action")}
			</Link>
		</Button>
	);
}

export default PasteWaFormButton;
